import Carousel from './components/Carousel/Carousel.svelte';
export default Carousel;